import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import DepartmentHome from "./DepartmentHome";

export default function DepartmentList() {
  const { t } = useTranslation();
  return (
     <Fragment>
            <Breadcrumbs mainTitle={t("List of Departments")} parent={t("Home")} title={t("List of Departments")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <DepartmentHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
